<mat-sidenav-container class="app-sidenav-component" id="app-sidenav-component">
  <mat-sidenav
    #sidenav
    mode="over"
    position="end"
    class="container"
    [fixedInViewport]="true"
    (openedChange)="toggleBodyScroll($event)"
  >
    <mat-sidenav-content #content>
      <ng-content></ng-content>
    </mat-sidenav-content>
  </mat-sidenav>
</mat-sidenav-container>
